import PetriModelling from "./petriModeling";

export default {
    __init__ : [
        'modeling'
    ],
    modeling: ['type', PetriModelling]
}